import { on, setAttribute, selectAll } from 'modules/dom'

export default function (el) {
  on('focus', function (e) {
    setAttribute('aria-expanded', true, el )
  }, el)

  if (el.previousSibling) {
    const deselectorsBefore = selectAll('.header__block a, .header__block [aria-expanded]')
    deselectorsBefore.map((deselector) => {
      on('focus', function (e) {
        setAttribute('aria-expanded', false, el )
      }, deselector)
    }, deselectorsBefore)
  }

  if (el.nextSibling) {
    const deselectorsAfter = selectAll('.header__nav a, .header__nav [aria-expanded]')
    deselectorsAfter.map((deselector) => {
      on('focus', function (e) {
        setAttribute('aria-expanded', false, el )
      }, deselector)
    }, deselectorsAfter)
  }
}
